export default {
  创作即收益: "創作即收益 <br />月月現金入帳",
  加入EBC创作者激励计划: "加入 EBC 創作者激勵計畫，輕鬆變現影響力",
  成为创作者: "成為創作者",
  无限奖励: "無限獎勵 全球曝光",
  EBC创作者激励计划:
    "EBC 創作者激勵計畫，將您的優勢轉化為規模化收益，輕鬆提升被動收入",
  推荐奖励: "推薦獎勵 人脈變現",
  推荐新用户注册并交易: "推薦新用戶註冊並交易，階梯變現月月結算",
  内容变现: "內容變現 認知即資本",
  在EBC: "在 EBC，知識不只是力量，更是收入",
  内容进阶: "內容進階 全球曝光",
  从本地创作到全球影响: "從本地創作到全球影響，一步進階，解鎖世界級流量",
  预计奖金: "預計獎金／月",
  均值估算仅供参考: "＊平均值僅供參考",
  "800万交易者的信任首选": "500 萬交易者的信賴首選",
  EBC用全球最佳券商的实力:
    "EBC 用全球最佳券商的實力，將影響力轉化為持續現金流，同時讓您獲得高額獎勵、全球頂級 IP 資源",
  全方位媒体曝光: "全方位媒體曝光",
  我们以全球媒体资源:
    "我們以全球媒體資源、攜手巴薩舉辦的多元化活動，為優質創作者提供內容扶持，助您快速建立個人品牌，提升品牌知名度",
  全球最强交易环境: "全球最強交易環境",
  打造极致交易体验:
    "打造極致交易體驗：毫秒級執行速度、機構級流動性、專業跟單社群，全方位助力安心交易，讓知識輕鬆變現",
  专属客户经理: "專屬客戶經理",
  我们为每位创作者配专属运营:
    "我們為每位創作者配專屬營運，全程一對一指導，協助您高效產出內容，獲得專業支持，收益最大化",
  如何成为创作者: "如何成為創作者",
  从内容创作到奖励提现: "從內容創作到獎勵提領，專屬顧問全程一對一支持",
  立即加入:"立即加入",
  注册提交资料:"註冊提交資料",
  发布专业内容:"發布專業內容",
  获取月度奖励:"獲取月度獎勵",
  活动须知:"活動須知",
  notices:[
    "1.創作者須擁有獨立內容專欄、自媒體帳號或社群渠道，具備至少三個月以上內容持續輸出能力，內容形式包括但不限於策略分析、圖文解讀、影音課程等。",
    "2.內容需保持原創性、專業性與合規性。若存在抄襲、洗稿或違規發布行為，平台有權取消其參與資格與相關權益。",
    "3.每月將依據創作者達標等級進行結算，合格者將於次月第一週獲得獎勵。",
    "4.本活動與其他活動（如基金經理成長計畫、代理扶持等）互斥，創作者需在報名時明確選擇參與路徑。",
    `5.平台將為優秀創作者配備專屬營運協助，提供內容支持與轉化資源；可聯繫客服或來信
              <a href="mailto:mkt@ebc.com">mkt@ebc.com</a> 進行諮詢。`,
    "6.為保障活動公平性，EBC 保留對本活動的最終解釋權，並有權取消任何形式的違規或濫用行為的參與資格。"
  ],
  section4Tips:""
};
